import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, MusicIcon, TypeIcon, StickerIcon, SlidersHorizontalIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function Preview() {
  const navigate = useNavigate();
  return <div className="w-full h-full bg-black relative flex flex-col" data-id="element-706">
      {/* Header */}
      <div className="absolute top-0 left-0 right-0 p-4 flex justify-between items-center z-20 bg-gradient-to-b from-black/60 to-transparent" data-id="element-707">
        <button onClick={() => navigate(-1)} className="text-white drop-shadow-md" data-id="element-708">
          <ArrowLeftIcon size={28} data-id="element-709" />
        </button>
        <button className="bg-surface/80 backdrop-blur-md px-4 py-1.5 rounded-full text-white text-sm font-bold" data-id="element-710">
          Retake
        </button>
      </div>

      {/* Video Preview Area */}
      <div className="flex-1 relative bg-gradient-to-br from-slate-800 to-slate-900 mt-16 mx-4 rounded-2xl overflow-hidden border border-border" data-id="element-711">
        <div className="absolute inset-0 flex items-center justify-center text-softGray" data-id="element-712">
          Video Preview
        </div>
      </div>

      {/* Bottom Tools & Next */}
      <div className="p-6 pb-8" data-id="element-713">
        <div className="flex justify-between mb-8 px-2" data-id="element-714">
          {[{
          icon: MusicIcon,
          label: 'Music'
        }, {
          icon: TypeIcon,
          label: 'Text'
        }, {
          icon: StickerIcon,
          label: 'Stickers'
        }, {
          icon: SlidersHorizontalIcon,
          label: 'Adjust'
        }].map((tool, i) => <button key={i} className="flex flex-col items-center gap-2 text-white" data-id="element-715">
              <div className="w-12 h-12 rounded-full bg-surface flex items-center justify-center border border-border" data-id="element-716">
                <tool.icon size={20} data-id="element-717" />
              </div>
              <span className="text-[10px] font-medium" data-id="element-718">{tool.label}</span>
            </button>)}
        </div>

        <Button fullWidth onClick={() => navigate('/upload/caption')} data-id="element-719">
          Next
        </Button>
      </div>
    </div>;
}